var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addResolutionStatus } from '../components/ResolutionStatus/services/ResolutionStatusService';
import { RESOLUTION_STATUS_QUERY_KEY } from '../components/ResolutionStatus/constants';
export default function useAddResolutionStatus() {
    const queryClient = useQueryClient();
    return useMutation((request) => addResolutionStatus(request), {
        onMutate: (newStatus) => __awaiter(this, void 0, void 0, function* () {
            yield queryClient.cancelQueries([RESOLUTION_STATUS_QUERY_KEY]);
            const tempId = Date.now() + Math.random();
            const previousStatuses = queryClient.getQueryData([RESOLUTION_STATUS_QUERY_KEY]);
            queryClient.setQueryData([RESOLUTION_STATUS_QUERY_KEY], (old) => old ? [...old, Object.assign(Object.assign({}, newStatus), { id: tempId })] : [Object.assign(Object.assign({}, newStatus), { id: tempId })]);
            return { previousStatuses };
        }),
        onError: (_, __, context) => {
            queryClient.setQueryData([RESOLUTION_STATUS_QUERY_KEY], context === null || context === void 0 ? void 0 : context.previousStatuses);
        },
        onSettled: () => {
            void queryClient.invalidateQueries([RESOLUTION_STATUS_QUERY_KEY]);
        }
    });
}
